import React from 'react'

interface ButtonProps {
  bgColor?: string
  textColor?: string
  children?: React.ReactNode
  disabled?: boolean
  onClick?: () => void
  className?: string
}

const Button: React.FC<ButtonProps> = ({
  bgColor = 'uriYellow',
  textColor = 'hibiscus',
  children = 'Button',
  disabled = false,
  onClick,
  className
}) => {
  return (
    <button
      type="button"
      disabled={disabled}
      onClick={onClick}
      className={`bg-${bgColor} text-${textColor} btn-shadow font-button-bahela rounded-full px-12 pb-2 py-4 leading-none m-0 cursor-pointer w-auto ${className}`}
    >
      {children}
    </button>
  )
}

export default Button
